import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "map-view d-flex flex-grow-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "map-container" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import Mapbox from "mapbox-gl";
import { Constants } from "@/classes/constants";
import { onMounted, onUnmounted, getCurrentInstance } from "vue";
import { useDataStore } from "@/store/data-store";
import ProjectTile from "@/components/Pages/ProjectTile.vue";
import router from "@/router";
import { Utils } from "@/classes/utils/utils";
import { ProjectInfo } from "@/swagger";
import { Vector2 } from "three";
import { useRoute } from "vue-router";
import { tenant } from "@/tenants/tenant";


export default /*#__PURE__*/_defineComponent({
  __name: 'MapView',
  setup(__props) {

const route = useRoute();
const dataStore = useDataStore();
const currentInstance = getCurrentInstance();

let map: Mapbox.Map;
// const mapType = ref<"satellite" | "map">("map");

onMounted(() => {
	Mapbox.accessToken = Constants.mapBoxAPIKey;
	map = new Mapbox.Map({
		container: "map-container",
		style: Constants.projectsMapStyle,
		center: [0,0],
		zoom: 3,
	});

	// disable map rotation using right click + drag
	map.dragPan.disable();
	map.dragRotate.disable();

	// disable map rotation using touch rotation gesture
	map.touchZoomRotate.disableRotation();

	//Switch controls to be panned by right mouse button
	var isMoving = false;
	var offset;
	map.on("contextmenu", () => { return undefined; });
	map.on("mousedown", (e) => {
		if (e.originalEvent.button === 1 || e.originalEvent.button === 2) {
			isMoving = true;
			offset = e.point;
		}
	});
	map.on("mousemove", (e) => {
		if (isMoving) {
			map.panBy([offset.x - e.point.x, offset.y - e.point.y], {
				duration: 0,
			});
			offset = e.point;
		}
	});
	map.on("mouseup", () => {
		isMoving = false;
	});

	loadProjectsOnMap();
});

onUnmounted(()=>{
	if(map){
		map.remove();
		map = null;
	}
});

async function loadProjectsOnMap() {
	const projects = await dataStore.getProjects();
	console.log("Loading projects on map");

	let minX = Number.MAX_VALUE;
	let maxX = Number.MIN_VALUE;
	let minY = Number.MAX_VALUE;
	let maxY = Number.MIN_VALUE;

	//Group projects by their coordinates
	var projectGroups: ProjectInfo[][] = [];
	for (const project of projects) {
		if(!project.latLong){
			continue
		}
		var sameGroup = projectGroups.find((g)=>g[0].latLong[0] == project.latLong[0] && g[0].latLong[1] == project.latLong[1]);
		if(!sameGroup){
			projectGroups.push([project])
		}else{
			sameGroup.push(project);
		}
	}

	for (const projectGroup of projectGroups) {
		for (let i = 0; i < projectGroup.length;i++) {
			const project = projectGroup[i];

			// create a HTML element for each feature
			const el = document.createElement("div");
			el.className = "project-marker";
			const img = document.createElement("img");

			img.src = project.previewImageUrl || tenant.assets.projectPlaceholderImageUrl;
			el.appendChild(img);

			var projectTile = Utils.mount(ProjectTile, {
				props: {
					project,
					showEditButton: false,
					showProjectStatus: false
				},
				context: currentInstance.appContext,
				element: undefined,
				children: undefined
			}).el;

			// make a marker for each feature and add to the map
			const marker = new Mapbox.Marker(el, { anchor: "bottom" });
			const popup = new Mapbox.Popup({ offset: 25, closeButton: false, anchor: "bottom" }).setDOMContent(projectTile);

			var rotation = new Vector2(0.0003,0);
			if(projectGroup.length > 1){
				var angle = (Math.PI*2)/(projectGroup.length+1);
				rotation.rotateAround(new Vector2(0,0),i * angle);
			}else{
				rotation.x = 0;
			}
			try{
				marker.setLngLat([parseFloat(project.latLong[1]) + rotation.x, parseFloat(project.latLong[0]) + rotation.y]);
			}catch(e){
				console.error("Error setting marker latLong: ", e);
				continue;
			}

			if (project.latLong[1] < minX) {
				minX = project.latLong[1];
			}
			if (project.latLong[1] > maxX) {
				maxX = project.latLong[1];
			}
			if (project.latLong[0] < minY) {
				minY = project.latLong[0];
			}
			if (project.latLong[0] > maxY) {
				maxY = project.latLong[0];
			}

			popup.on("open", () => {
				el.classList.add("active");
			})
			popup.on("close", () => {
				el.classList.remove("active");
			})
			if (Utils.canViewProject(project)) {
				projectTile.addEventListener("click", () => {
					router.push({ name: "view", params: { projectId: project.uuid } })
				});
			}
			marker.setPopup(popup);
			marker.addTo(map);
		}
	}

	if(route.query.mapProject){
		var mapProject = projects.find((p)=>p.uuid == route.query.mapProject);
		if(mapProject){
			var x = parseFloat(mapProject.latLong[1]);
			var y = parseFloat(mapProject.latLong[0]);
			minX = x - 0.01;
			maxX = x + 0.01;
			minY = y - 0.01;
			maxY = y + 0.01;
		}
		//Delete map project from query params
		var query = Object.assign({}, route.query);
		delete query.mapProject;
		router.replace({query});
	}
	
	map.fitBounds([
		[minX, minY],
		[maxX, maxY]
	], {
		padding: 100
	})
	
	console.log("Bounds ", minX, maxX, minY, maxY)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})